import { render, staticRenderFns } from "./PizzaChartAnswered.vue?vue&type=template&id=7f642f95"
import script from "./PizzaChartAnswered.vue?vue&type=script&lang=js"
export * from "./PizzaChartAnswered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports